import { Loader2 } from 'lucide-react';
import {
  CAMPAIGN_STATUS_LABELS,
  CAMPAIGN_STATUS_COLORS,
  CAMPAIGN_TYPE_LABELS,
  type CampaignStatus,
  type CampaignType,
} from '../types';

export function CampaignStatusBadge({ status }: { status: CampaignStatus }) {
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${CAMPAIGN_STATUS_COLORS[status]}`}>
      {status === 'running' && <Loader2 className="h-2.5 w-2.5 animate-spin" />}
      {CAMPAIGN_STATUS_LABELS[status]}
    </span>
  );
}

export function CampaignTypeBadge({ type }: { type: CampaignType }) {
  const colors: Record<CampaignType, string> = {
    whatsapp: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/25',
    email:    'bg-blue-500/15 text-blue-300 border-blue-500/25',
    sms:      'bg-purple-500/15 text-purple-300 border-purple-500/25',
  };
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${colors[type]}`}>
      {CAMPAIGN_TYPE_LABELS[type]}
    </span>
  );
}
